module.exports = __webpack_public_path__ + "static/media/3.a55ea5fd.jpg";